import React,{useState, useEffect} from 'react'
import removal1 from '../images/removal1.jpeg';
import removal2 from '../images/removal21.jpeg';
import removal3 from '../images/removal13.jpeg';
import removal4 from '../images/removal2.jpeg';
import removal5 from '../images/removal10.jpeg';
import removal6 from '../images/removal7.jpeg';
import removal7 from '../images/removal8.jpeg';
import removal8 from '../images/removal12.jpeg';
// import removal9 from '../images/removal9.jpeg';
import removal10 from '../images/removal4.jpeg';
// import removal11 from '../images/removal11.jpeg';
import removal12 from '../images/removal5.jpeg';
// import removal13 from '../images/removal3.jpeg';
import removal14 from '../images/removal14.jpeg';
import removal15 from '../images/removal15.jpeg';
import removal16 from '../images/removal16.jpeg';
import removal17 from '../images/removal17.jpeg';
import removal18 from '../images/removal19.jpeg';
import removal19 from '../images/removal18.jpeg';
import removal20 from '../images/removal20.jpeg';
import removal21 from '../images/removal6.jpeg';

const allPics = [
  removal1,
  removal2,
  removal3,
  removal4,
  removal5,
  removal6,
  removal7,
  removal8,
  // removal9,
  removal10,
  // removal11,
  removal12,
  // removal13,
  removal14,
  removal15,
  removal16,
  removal17,
  removal18,
  removal19,
  removal20,
  removal21
];

function Removal() {


    const [removalPics, setRemovalPics] = useState([]);
    const [isCollapsed, setIsCollapsed] = useState(true);


    useEffect( () => {
      if(!isCollapsed){
        const picsToUse = allPics.map( (el, i) => {
          return (
          
            <div>
              <img src={el} alt="" /> 
            </div>
          )
        });
        setRemovalPics(picsToUse);
        
      }else{
        const picsToUse = [];
        for(let i = 0; i < 8; i++){
          picsToUse.push((
            <div>
              <img src={allPics[i]} alt="" />
            </div>
          ));
        }
        setRemovalPics(picsToUse);


      }
    }, [isCollapsed]);


  return (
    <section id= "removal-service" className= "service-container">
      <h2>Removal</h2>
      <p id= "removal-description">Overwhelmed with junk but not interested in the hassle of loading it yourself? Ideal Disposal has got you covered. 
        Just send us photos of the items you need removed to <a href="mailto:IdealDisposalServices@gmail.com">IdealDisposalServices@gmail.com</a>, and we'll provide you with an estimate. We assess the volume, weight, and time required to clear your space, ensuring a fair and straightforward quote. Let us know the day that works best for you, and we'll do our best to accommodate your schedule. Experience a stress-free junk removal process with Ideal Disposal – we're here to take the burden off your hands efficiently and reliably!</p>
      <div id= "removal-images">
        {/* <div>
          <img src={removal1} alt="" />
        </div>
        <div>
        <img src={removal2} alt="" />
        </div>
        <div>
          <img src={removal3} alt="" />
        </div>
        <div>
        <img src={removal4} alt="" />
        </div>
        <div>
          <img src={removal5} alt="" />
        </div>
        <div>
        <img src={removal6} alt="" />
        </div> */}
        {removalPics}
      </div>
      { isCollapsed? <p className = 'show-more-text'><span onClick = { () => {
        setIsCollapsed( prev => !prev);
      }}>Show more</span></p> : <p className = 'show-more-text'><span onClick = { () => {
        setIsCollapsed( prev => !prev);
      }}>Show less</span></p>}

    </section>
  )
}

export default Removal;